declare var composite_json;
declare var price_combinations;
export class composite_products {
    constructor() {
        this.Init();
    }

    Init() {
        let product_selects = jQuery('.composite-select_container.product-select')
        product_selects.each((index, element) => { this.selectSetup(element) });
    }

    fieldGroups = []

    selectSetup(element) {
        let mainObj = this;
        let elementObj = jQuery(element);
        elementObj.find('.composite-image').css('background-image', 'url(' + elementObj.find('.composite-image').attr('data-base') + ')');
        this.fieldGroups.push(false);

        elementObj.find('select.composite-select').on('change', function () {
            let product = composite_json[(this as HTMLSelectElement).value];
            if (product != undefined) {
                elementObj.find('.composite-image').css('background-image', 'url(' + product['image'] + ')');
                elementObj.find('.stock-notice').html(product['stock-notice']);
                mainObj.fieldGroups[elementObj.attr('data-field_id')] = product['group']
                mainObj.testCart();
            }
        });
        elementObj.find('select.composite-select').trigger('change');
        jQuery('select[name="custom_box"]').on('change', () => {
            this.testCart();
        })
    }

    testCart() {
        let combination = this.fieldGroups.slice() as any;
        combination = combination.sort()
        combination = combination.join('+');
        let price = price_combinations[combination];
        if (price != null) {
            jQuery('.composite-price').html(price);
            jQuery('.single_add_to_cart_button.button').prop('disabled', false);
        } else {
            jQuery('.composite-price').html('');
            jQuery('.single_add_to_cart_button.button').prop('disabled', true);
        }
        if (jQuery('select[name="custom_box"]').length) {
            if (jQuery('select[name="custom_box"]').val() == null) {
                jQuery('.single_add_to_cart_button.button').prop('disabled', true);
            }
        }
    }
}